import React, { useContext } from 'react';

import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import cx from 'classnames';

import AddMinusButton from 'components/shared/AddMinusButton';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';

import LandingPageContext from '../../contexts/LandingPageContext';
import { useListBlockItem } from './functions';
import s from './index.module.css';
import ListBlockItem from './Item';
import { IListBlockItemData } from './Item/types';
import { IListBlockProps } from './types';

function ListBlock(props: IListBlockProps) {
  const { items, handleDeleteItem, handleChangeItem, handleAddItem, sensors, handleDragEnd, itemsDndIds } =
    useListBlockItem(props);
  const { readOnly } = useContext(LandingPageContext);

  return (
    <div className={cx(s.wrapper, 'custom-listblock-wrapper')}>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        // onDragStart={({ active }) => {
        //   if (!active) {
        //     return;
        //   }
        //   document.body.classList.add('dragging');
        // }}
        onDragEnd={handleDragEnd}
        // onDragCancel={() => {
        //   document.body.classList.remove('dragging');
        // }}
      >
        <SortableContext items={itemsDndIds} strategy={verticalListSortingStrategy}>
          {itemsDndIds.map((id) => (
            <ListBlockItem
              key={id}
              id={id}
              data={items[Number(id)]}
              onChange={(data: IListBlockItemData) => handleChangeItem(id, data)}
              onDelete={items?.length > 1 && ((() => handleDeleteItem(id)) as any)}
            />
          ))}
          {!readOnly && (
            <FormActions isCenter>
              <AddMinusButton onClick={handleAddItem} />
            </FormActions>
          )}
        </SortableContext>
      </DndContext>
    </div>
  );
}

export default ListBlock;
